import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard, CheckCircle2, Mail, Instagram } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'MR',
    name: 'Martín R.',
    location: 'Argentina',
    product: 'Compró el Megapack',
    text: 'No me animaba a realizar colores por que me quitaba mucho tiempo. Ahora los trabajos que hago me salen 10 puntos, muy bueno lo recomiendo.',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CP',
    name: 'Carlos P.',
    location: 'Colombia',
    product: 'Compró el Megapack',
    text: 'No tenía el conocimiento para hacer un color. Ahora mis clientes me piden trabajos complejos y me quedan perfectos.',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'DG',
    name: 'Diego G.',
    location: 'México',
    product: 'Compró el Megapack',
    text: 'Es muy práctico, en mi caso imprimí los manuales. Los tengo en mi negocio. Los videos me ayudaron para saber exactamente qué hacer.',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Uruguay',
    product: 'Compró el Megapack',
    text: 'No sabía donde estudiar. Desconfiaba de todo, pero por suerte compre este curso y viene con todo completo. Muy recomendable.',
    bg: 'bg-brandSteel-deep text-white'
  }];
  return <Section className="bg-bg-alt" data-id="element-183" data-mp="3pd1kacbg09gc">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-184" data-mp="1zx26ghwvpvud">
        <h2 className="font-display font-bold uppercase md:text-[40px] text-txt-primary mb-3 md:mb-4 text-[24px] tracking-[0.5px]" data-id="element-185" data-mp="1zxu0hoatvlij">
          Lo que dicen{' '}
          <span className="text-brandGold" data-id="element-186" data-mp="3v10a44sqa5zu">los que ya dominan</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-187" data-mp="3u5pyomc0asw">
          <div className="flex text-gold" data-id="element-188" data-mp="7v99bl3l8oyv">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-189" data-mp="culv02iq3pzv" data-mpi={j} />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-190" data-mp="htyfigm4gkza">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-191" data-mp="msrw4hwpgs3o">
            · +500 barberos de Latinoamérica
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-192" data-mp="rlurmvl1mbmi">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-193" data-mp="10kg366s3kqds" data-mpi={i}>
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-194" data-mp="10lzkm0php7h5">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-195" data-mp="15jsv35xtsnn8">
                <div className={`w-9 h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-196" data-mp="1fohj5dwhglvw">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-197" data-mp="15psa8amkebrs">
                  <div className="flex text-gold mb-0.5" data-id="element-198" data-mp="11nye8fnbdvxy">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-199" data-mp="1yeh3jnhdpcsz" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-200" data-mp="1tfw3bo24mt4j">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-201" data-mp="1olrut0d7qd1c">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-202" data-mp="2h607pxn52wwl">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto" data-id="element-203" data-mp="1wvyzihse2k7a">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-204" data-mp="1rwmgy98jvzai">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-205" data-mp="1rxnq2860abpl">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-6 md:p-10 relative overflow-hidden" data-id="element-206" data-mp="2fm6xyml58mh5">
          <ShieldCheck size={70} className="mx-auto text-success mb-5 md:mb-6 relative z-10" data-id="element-207" data-mp="2kljk1546xpio" />
          <h2 className="font-display font-bold uppercase text-[22px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-208" data-mp="26tdgcii85b04">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-209" data-mp="2yiyhmx4ll3lq">
            <p data-id="element-210" data-mp="rvhlkldut1fe">
              Accedes a TODO. Ves los videos. Descargas los manuales. Los
              imprimes. Los usas en tu próximo cliente.
            </p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-211" data-mp="11mc9rvanub3h">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-212" data-mp="wo0vn8dc1efg" />
              devolución del 100%.
            </p>
            <p data-id="element-213" data-mp="8x52a6t8ab63">Sin formularios. Sin complicaciones. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-214" data-mp="3zd7n5178ay7">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Es para alguien que recién empieza o que ya trabaja?',
    a: 'Es para ambos, para el que tiene cero conocimiento ya que explicamos desde la base, tanto como para los BARBEROS que ya trabajan y necesitan descubrir los secretos y las técnicas para dominar la colorimetría'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en (USD), pero el sistema convierte automáticamente a tu moneda local en el checkout.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Instantáneamente en tu correo. Todos los videos, PDFs y bonos listos para descargar. Puedes verlo en tu celular o descargarlo e imprimirlo.'
  }, {
    q: '¿Necesito alguna certificación previa para aprovecharlo?',
    a: 'No. Solo que tengas experiencia trabajando en barbería. El sistema es progresivo: desde fundamentos hasta técnicas avanzadas.'
  }, {
    q: '¿Funciona si trabajo de forma independiente y no en una barbería?',
    a: '100%. Muchos usuarios trabajan en sus propios locales o en domicilios. El sistema se adapta.'
  }, {
    q: '¿Tiene garantía real o es un bluff?',
    a: 'Garantía real. 7 días completos. Si no te gusta, te devolvemos el dinero. Punto.'
  }, {
    q: '¿Puedo usar el megapack con mis clientes?',
    a: 'Sí. Los manuales son tuyos. Los videos también. Los bonos (fichas, cartas de color) están diseñados para usar con clientes.'
  }, {
    q: '¿Por cuánto tiempo tengo acceso?',
    a: 'Para siempre. Pago único. Acceso ilimitado.'
  }, {
    q: '¿Qué formato exacto es?',
    a: '15 Módulos en Videos MP4 HD (descargables). 4 Manuales Completos (descargables). 5 Bonos (descargables e imprimibles).'
  }, {
    q: '¿Hay actualizaciones incluidas?',
    a: 'Sí. Si agregamos nuevas técnicas o módulos, tú los recibes sin costo extra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-215" data-mp="2gik3ejz92qtr">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-216" data-mp="2gjbw9n1gqagc">
        <h2 className="font-display font-bold uppercase text-[24px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-txt-primary text-center mb-8 md:mb-10" data-id="element-217" data-mp="2bixp077or4jd">
          ❓ LO QUE MÁS NOS <span className="text-brandGold" data-id="element-218" data-mp="3vdinlqa1tvpq">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-219" data-mp="3vea742qdg2zn">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-220" data-mp="396dmhnoiko6" data-mpi={i}>
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-221" data-mp="3qcuqcmv88in2">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-222" data-mp="32pwanrexleq7">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandGold shrink-0" size={20} data-id="element-223" data-mp="2sq5i3v9xl9sr" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-224" data-mp="2xq9zromksakk" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-225" data-mp="2e61c9v5tq691">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: 'Años buscando en YouTube, Instagram y con otros barberos',
    costo: 'Conocimiento disperso y sin sistema'
  }, {
    sin: '3-4 horas buscando cada fin de semana',
    costo: '156-208 horas perdidas por año (4-5 semanas de trabajo)'
  }, {
    sin: 'No tener TODO en un lugar organizado',
    costo: 'Sesiones sin estructura, improvisación'
  }, {
    sin: 'Cometer errores químicos constantemente',
    costo: 'Clientes insatisfechos, mala reputación, dinero perdido'
  }, {
    sin: 'No dominar realmente las técnicas',
    costo: 'Nunca llegar a precios premium'
  }, {
    sin: 'Seguir comprando cursos sueltos y costosos',
    costo: 'Dinero y tiempo desperdiciados sin fin'
  }];
  return <Section className="bg-bg-base" data-id="element-226" data-mp="347flaard3b92">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-227" data-mp="348h3r0apj00t">
        <h2 className="font-display font-bold uppercase text-[26px] md:text-[40px] leading-[1.2] tracking-[0.5px] text-center text-txt-primary mb-8 md:mb-12" data-id="element-228" data-mp="306m21uov6kmi">
          ⚖️ ¿CUÁNTO CUESTA
          <br data-id="element-229" data-mp="3rxickongcd6m" />
          <span className="text-brandGold" data-id="element-230" data-mp="3rx09b82dgyp7">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-231" data-mp="3rvp7veweg319">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-232" data-mp="3ix3o5gf6yhyw">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-233" data-mp="3iz6e60gcgb3m">
              Sin el Megapack
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-234" data-mp="27hf2qthl5r07">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-235" data-mp="ryh43ezhovxx">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-236" data-mp="w0c3uf1rv19l" data-mpi={i}>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-237" data-mp="10ru6d7jg19wo">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-start gap-1.5" data-id="element-238" data-mp="1aop2jjs8uy7s">
                  <span aria-hidden="true" data-id="element-239" data-mp="1jpmxlckpfve8">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-[14px] md:text-xl text-center text-txt-primary w-full mx-auto" data-id="element-240" data-mp="3hh94pdyqamw9">
          Tu próximo color puede ser diferente ...
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds,
    isUrgent
  } = useCountdown();
  const accent = isUrgent ? 'text-danger' : 'text-brandGold';
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-241" data-mp="11npvlech5ba0">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-242" data-mp="xlcrsvhafnfv">
        {/* Urgency intro copy */}
        <div className="mb-8 md:mb-10" data-id="element-243" data-mp="1bl40qhsy6dn0">
          <p className="font-display font-bold uppercase text-[20px] md:text-[32px] leading-[1.3] tracking-[0.5px] text-txt-primary" data-id="element-244" data-mp="1bk2r8hrkxz7e">
            Puedes seguir perdiendo{' '}
            <span className="text-brandGold" style={{
            textShadow: '0 0 12px rgba(212,162,76,0.28)'
          }} data-id="element-245" data-mp="1laf73wog9477">
              clientes,
            </span>
            
            <br data-id="element-246" data-mp="1uceoiq3dmaao" />o tener TODO el CURSO — organizado, listo, aplicable.
          </p>
          <p className="font-display font-bold uppercase text-[26px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-brandGold animate-pulse mt-3" data-id="element-247" data-mp="1pedaijkt5162">
            Tú decides.
          </p>
        </div>

        <div className="mb-10 md:mb-12" data-id="element-248" data-mp="2dxexv2nxaxza">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-3 animate-pulse" data-id="element-249" data-mp="1zy5syz563qam">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-250" data-mp="1q82pg50f6ty1"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className={`font-sans font-bold uppercase tracking-[1.5px] text-[11px] mb-3 md:mb-4 ${accent}`} data-id="element-251" data-mp="1v0dqjb6wcls6">
            ⏰ EL PRECIO DE LANZAMIENTO CIERRA EN:
          </h3>
          <div className={`inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 px-5 py-3 md:px-6 md:py-4 rounded-[14px] transition-colors ${isUrgent ? 'border-danger shadow-[0_0_30px_rgba(239,68,68,0.45)] animate-red-glow' : 'border-brandGold shadow-[0_0_30px_rgba(212,162,76,0.35)] animate-glow-button'}`} data-id="element-252" data-mp="1l9j3i4ltti5o">
            {[hours, minutes, seconds].map((unit, i) => <React.Fragment key={i} data-id="element-253" data-mp="uhajfx2s5sbz" data-mpi={i}>
                {i > 0 && <span className={`font-display font-bold text-[30px] md:text-[40px] leading-none ${accent}`} data-id="element-254" data-mp="qggvx4t92fjm">
                    :
                  </span>}
                <span className={`font-display font-bold text-[30px] md:text-[40px] leading-none ${accent}`} data-id="element-255" data-mp="gikp2p7ci6rb">
                  {unit.toString().padStart(2, '0')}
                </span>
              </React.Fragment>)}
          </div>
          <p className="font-sans font-bold text-[11px] md:text-[13px] text-danger mt-3 uppercase tracking-[1.5px]" data-id="element-256" data-mp="7jz3smahodmu">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10 md:mb-12" data-id="element-257" data-mp="21tt5lwboxsdp">
          <div className="bg-bg-card rounded-[22px] p-5 md:p-8 border-2 border-brandGold text-left shadow-[0_0_50px_rgba(212,162,76,0.18)]" data-id="element-258" data-mp="3jshcgdam7gxz">
            <h4 className="font-display font-bold uppercase text-[16px] md:text-[22px] leading-[1.25] tracking-[0.5px] text-txt-primary text-center" data-id="element-259" data-mp="3oq0s9hmyo1s1">
              MEGAPACK COLORIMETRÍA{' '}
              <span className="text-brandGold" data-id="element-260" data-mp="1h41lghdbeua">LISTA™</span>
            </h4>
            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mt-2 mb-3 md:mb-4" data-id="element-261" data-mp="30vzevf934mtt">
              Lo que incluye:
            </p>

            <ul className="space-y-2 md:space-y-2.5" data-id="element-262" data-mp="39tjfqn31ch3w">
              {['15 Módulos en Video HD — 15 horas de entrenamiento', '4 Manuales Completos — 475+ páginas organizadas', '5 Bonos listos para imprimir — Sin costo extra', 'TODO lo que necesitas dominar en un solo acceso', 'Acceso inmediato y para siempre'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-263" data-mp="2q8xuwxdcy4h4">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-264" data-mp="2m4yiapv77pt1" />
                  <span className="font-sans text-[12.5px] md:text-[15px] leading-[1.45] text-txt-body" data-id="element-265" data-mp="2v66en2e5mgkh">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-4 md:mt-5 pt-3 md:pt-4 border-t border-line text-center" data-id="element-266" data-mp="22hsheouw3o9z">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-267" data-mp="2h6eusl0yi5yk">
                Valor original
              </p>
              <p className="font-display font-bold text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-268" data-mp="2cedn7ceqh3ev">
                USD $155
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandGold/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-269" data-mp="1jqhsuecmznl9">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandGold" data-id="element-270" data-mp="3vcjmsiv5txcv">
                Acceso completo hoy por
              </p>
              <p className="font-display font-bold text-[40px] md:text-[54px] leading-none text-brandGold mt-1" data-id="element-271" data-mp="3mf98eon1ps3q">
                $24{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-272" data-mp="hzgh8phcqc8i">
                  USD
                </span>
              </p>
              <p className="font-sans font-bold text-[11px] md:text-[13px] text-success mt-2" data-id="element-273" data-mp="my1bm89xa1p1">
                85% de descuento — Solo en lanzamiento
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-274" data-mp="dx3e88tzosff">
                Pago único · Acceso inmediato
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-275" data-mp="2yo3syal0p1ty" />

            <div className="mt-4 md:mt-5" data-id="element-276" data-mp="2yponw1b8umsc">
              <CTAButton href={PRODUCTS.megapack.checkoutUrl} fullWidth trackingProduct="megapack" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[12px] md:!text-[15px]" data-id="element-277" data-mp="3pdxgsqlq7bus">
                🎨 SÍ, QUIERO DOMINAR LA COLORIMETRÍA — ACCESO AHORA
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-278" data-mp="cx209spnlkap">
          <span className="flex items-center gap-2" data-id="element-279" data-mp="7y7eqj0axhmw">
            <Lock size={14} data-id="element-280" data-mp="36pc7qimr8zt" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-281" data-mp="34w6qejr6ute">
            <Clock size={14} data-id="element-282" data-mp="3ue1uk8v91shb" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-283" data-mp="vn9vzpr0x8gv">
            <ShieldCheck size={14} data-id="element-284" data-mp="vouprd5ikndo" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-285" data-mp="qw9yojdzsodu">
            <CreditCard size={14} data-id="element-286" data-mp="y7y2fbsw89ds" /> Tarjeta | Débito | Pago local en tu moneda
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-287" data-mp="138m2so30i2ko">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-288" data-mp="184ay2f800xb6">
        <div data-id="element-289" data-mp="1d58o1dz92vn8">
          <h2 className="font-display font-bold uppercase tracking-[0.5px] text-base md:text-xl text-txt-primary mb-1 leading-snug" data-id="element-290" data-mp="1d60c83qipr3h">
            🎨 MEGAPACK COLORIMETRÍA LISTA™
          </h2>
          <p className="font-sans font-bold text-sm text-brandGold" data-id="element-291" data-mp="1m4lnddtnu3u8">
            by NERO BARBER
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-292" data-mp="1qwvl3g10o872">
          El megapack profesional número 1 para barberos en Latinoamérica.
          Porque aprender disperso en 10 lugares es perder años. Aquí lo tienes
          TODO: videos, manuales, fórmulas exactas y bonos de impacto.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 font-sans text-[13px] text-txt-muted pt-4" data-id="element-293" data-mp="24u23h9htw4vr">
          <a href="mailto:Soportenerobarber@gmail.com" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-294" data-mp="39athxrryv1gg">
            <Mail size={14} aria-hidden="true" data-id="element-295" data-mp="3ic1g89uhg2aj" />
            Soportenerobarber@gmail.com
          </a>
          <a href="https://www.instagram.com/Nero_barber_ok" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-296" data-mp="3nb49yy50im37">
            <Instagram size={14} aria-hidden="true" data-id="element-297" data-mp="wunwvok1q5l" />
            @Nero_barber_ok
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-298" data-mp="5u3b5aok8kdp">
          <p className="font-sans text-xs text-txt-faint" data-id="element-299" data-mp="9wzkeas7n44z">
            © 2025 NERO BARBER. Todos los derechos reservados. Precios en
            dólares (USD) · Cobro en tu moneda local.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-300" data-mp="1zdlob95jgp3o">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-301" data-mp="1ue8qjtd4pxmb">
              Términos y condiciones
            </a>
            <span data-id="element-302" data-mp="1qbvnxdtoiftr">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-303" data-mp="1qd712490kzxj">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};